import ExerciseItem from 'core/modules/components/lists/ExerciseLibraryList/ExerciseItem/ExerciseItem';
import BasicList from 'core/modules/components/lists/components/BasicList';
import PropTypes from 'prop-types';
import React from 'react';
import OptionalCheckboxGroup from 'core/modules/components/lists/components/OptionalCheckboxGroup/OptionalCheckboxGroup';

const ExcerciseLibraryList = ({ t, items, selectedItems, onChangeSelected, selectJustOne, legend, isLegendHidden }) => {
  const content = (
    <BasicList
      items={items.map((item) => {
        return (
          <div className="unit-list__entry" key={item.guid}>
            <ExerciseItem
              t={t}
              name={item.title}
              description={item.description}
              authorGuid={item.author_guid}
              isAutoevaluative={item.question_is_autoevaluative}
              guid={item.guid}
              image={item.image}
              selected={selectedItems.some((question) => question.guid === item.guid)}
              onChangeSelected={() => onChangeSelected(item.guid)}
              activity={item}
              disabled={item.disabled}
              selectJustOne={selectJustOne}
              selectedItems={selectedItems}
              learningObjectives={item.learningObjectives || []}
              tags={item.tags || []}
            />
          </div>
        );
      })}
    />
  );

  return (
    <OptionalCheckboxGroup className="unit-list" isLegendHidden={isLegendHidden} legend={legend}>
      {content}
    </OptionalCheckboxGroup>
  );
};

ExcerciseLibraryList.propTypes = {
  isLegendHidden: PropTypes.bool,
  items: PropTypes.array,
  legend: PropTypes.string,
  onChangeSelected: PropTypes.func,
  selectJustOne: PropTypes.bool,
  selectedItems: PropTypes.array,
  t: PropTypes.func,
};

ExcerciseLibraryList.defaultProps = {};

export default ExcerciseLibraryList;
